module.exports = __webpack_public_path__ + "static/media/Cropped_Twodash_white.147008c4.svg";